export default {
    getStarted: 'Get started',
    next: 'Next',
    previous: 'Previous',
    step: 'Step',
    icons: {
        copyright: 'mdi-account-circle-outline',
    }
};
